import React, { createContext, useState } from 'react'

type AvailableFiltersType = {
  date?: Date | null;
  departments?: Array<string>;
  pageRows?: number;
  pageStart?: number;
  policyId?: string;
  term?: string;
  tag?: string;
}
type FilterProviderStateType = {
  [key: string]: AvailableFiltersType;
}
type FilterProviderContextType = {
  filters: FilterProviderStateType;
  sideBoxFilter: string;
  updateFilter: (policyId: string, filterData: AvailableFiltersType) => void;
  updateSideBoxFilter: (param: string) => void;
}
interface FilterProviderProps {
  children: any
}

const initialState = {
  date: null,
  departments: [],
  pageRows: 0,
  pageStart: 0,
  policyId: '',
  term: '',
  tag: ''
}

export const FilterContext = createContext<FilterProviderContextType>({
  filters: {},
  sideBoxFilter: '1',
  updateFilter: () => null,
  updateSideBoxFilter: () => null
})

const FilterProvider: React.FC<FilterProviderProps> = ({ children }) => {

  const [filters, setFilters] = useState<FilterProviderStateType>({})
  const [sideBoxFilter, setSideBoxFilter] = useState<string>('1')

  const updateFilter = (policyId, data) => {
    const keys = Object.keys(filters)
    const selectedKey = keys[policyId] || policyId
    const selectedFilter = filters[selectedKey]

    setFilters((prevState) => {
      return { ...prevState, [selectedKey]: { ...initialState, ...selectedFilter, ...data, policyId }}
    })
  }

  const updateSideBoxFilter = (param: string) => {
    setSideBoxFilter(param)
  }

  return (
    <FilterContext.Provider
      value={{
        filters,
        sideBoxFilter,
        updateFilter,
        updateSideBoxFilter
      }}
    >
      {children}
    </FilterContext.Provider>
  )
}

export default FilterProvider
